import Godaam from "main/src/js/utils/storage";
import { Stack } from "@certa/catalyst/layouts/Stack";
import { useScreenResolution } from "@certa/common/hooks/useScreenResolution";
import { HeaderMode } from "@certa/common/constants";
import { NavigationSidebar } from "@certa/common/components/NavigationSidebar";
import { Header } from "@certa/common/components/Header";
import { CloseIframe } from "@certa/common/components/CloseIframe";
import { MobileHeader } from "@certa/common/components/MobileHeader/MobileHeader";
import { StudioHeaderV2 } from "@certa/common/components/Header/StudioHeaderV2/StudioHeaderV2";
import { useIsStudioV3Enabled } from "@certa/common/toggles/useDesignAIToggles";

type HeaderWrapperProps = {
  children: React.ReactNode;
  headerMode?: HeaderMode;
  shouldShowUserProfile?: boolean;
};

export const HeaderWrapper = ({
  children,
  headerMode: headerModeProp = HeaderMode.DEFAULT,
  shouldShowUserProfile = true
}: HeaderWrapperProps) => {
  const isEmbeddedView = Godaam.isEmbeddedView;
  const isStudioV3Enabled = useIsStudioV3Enabled();
  const { isMobileResolution } = useScreenResolution();

  const headerMode =
    !isStudioV3Enabled && headerModeProp === HeaderMode.STUDIO_V2
      ? HeaderMode.STUDIO
      : headerModeProp;

  const shouldShowNavigationSidebar =
    headerMode !== HeaderMode.NONE &&
    headerMode !== HeaderMode.STUDIO &&
    headerMode !== HeaderMode.STUDIO_V2 &&
    !isEmbeddedView &&
    !isMobileResolution;

  const shouldShowMobileHeader = isMobileResolution;

  const shouldShowHeader =
    headerMode !== HeaderMode.NONE &&
    headerMode !== HeaderMode.STUDIO_V2 &&
    !isEmbeddedView;

  const shouldShowStudioHeaderV2 =
    headerMode === HeaderMode.STUDIO_V2 && !isEmbeddedView;

  return (
    <Stack
      direction={isMobileResolution ? "vertical" : "horizontal"}
      height="100%"
    >
      {shouldShowNavigationSidebar && <NavigationSidebar />}
      {shouldShowMobileHeader && <MobileHeader />}
      <Stack width="100%" height="100%" overflow="auto">
        <div id="catalyst-positioned-drawer-wrapper" />
        {shouldShowHeader && <Header mode={headerMode} />}
        {shouldShowStudioHeaderV2 && (
          <StudioHeaderV2 shouldShowUserProfile={shouldShowUserProfile} />
        )}
        {Godaam.exitIframeButton && <CloseIframe />}
        {children}
      </Stack>
    </Stack>
  );
};
